import Term from './Term';
import {
  DEFAULT_SPEAKER, PUNC, TURN, WORD,
} from './constants';

export default (transcript) => {
  if (!Array.isArray(transcript)) throw new Error('bad data fed to transcriptCompiler');
  const value = transcript.map((w, index) => {
    const wValue = w.w;
    let metaType = WORD;
    switch (w.meta) {
      case PUNC:
        metaType = PUNC;
        break;
      case TURN:
        metaType = TURN;
        break;
      default:
        metaType = WORD;
    }
    const props = {
      ...w,
      index,
      type: metaType=== TURN ? 'word:turn' : 'word',
      metaType,
    };

    return new Term({
      props,
      value: wValue,
    });
  });

  return new Term({
    value,
    props: {
      speakers: new Set([DEFAULT_SPEAKER]),
    },
  });
};
